import * as React from 'react';
import './Modal.css';
import { Modal as AntdModal } from 'antd';

function Modal(props) {
  const defaultWidth = '220px';
  const modalClasses = `Modal ${props.className}`;

  return (
    <AntdModal
      className={modalClasses}
      title={props.title}
      visible={props.visible}
      width={props.width || defaultWidth}
      closable={!props.hideCloseButton}
      footer={null}
      centered={true}
      keyboard={true}
      maskClosable={true}>
      {props.children}
    </AntdModal>
  );
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/Modal.jsx